import type { Signal } from '@angular/core';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable } from 'rxjs';

import { Language } from '@customer-portal/shared';

import { SetProfileLanguage, UpdateProfileLanguage } from '../actions';
import { ProfileLanguageSelectors } from '../selectors';

@Injectable({ providedIn: 'root' })
export class ProfileLanguageStoreService {
  constructor(private store: Store) {}

  get portalLanguage(): Signal<Language> {
    return this.store.selectSignal(ProfileLanguageSelectors.portalLanguage);
  }

  get profileDataLanguageError$(): Observable<string | null> {
    return this.store.select(
      (state) => state.settings.loadingErrors.profileDataLanguage,
    );
  }

  get profileLanguageDataLoaded$(): Observable<boolean> {
    return this.store.select(
      (state) => state.settings.loadedStates.profileLanguage,
    );
  }

  @Dispatch()
  setProfileLanguage = (portalLanguage: string) =>
    new SetProfileLanguage(portalLanguage);

  @Dispatch()
  updateProfileLanguage = (portalLanguage: Language) =>
    new UpdateProfileLanguage(portalLanguage);
}
